import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import SmoothScroll from "@/components/SmoothScroll";
import IntroLoader from "@/components/IntroLoader";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Amenities from "@/pages/Amenities";
import Gallery from "@/pages/Gallery";
import TestimonialsPage from "@/pages/TestimonialsPage";
import Journal from "@/pages/Journal";
import JournalEntry from "@/pages/JournalEntry";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";

function App() {
    return (
        <div className="App grain">
            <BrowserRouter>
                <SmoothScroll>
                    <IntroLoader />
                    <ScrollToTop />
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/projects" element={<Projects />} />
                            <Route path="/projects/:slug" element={<ProjectDetail />} />
                            <Route path="/amenities" element={<Amenities />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/testimonials" element={<TestimonialsPage />} />
                            <Route path="/journal" element={<Journal />} />
                            <Route path="/journal/:slug" element={<JournalEntry />} />
                            <Route path="/careers" element={<Careers />} />
                            <Route path="/contact" element={<Contact />} />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster theme="dark" position="bottom-right" />
                </SmoothScroll>
            </BrowserRouter>
        </div>
    );
}

export default App;
